import { render, staticRenderFns } from "./ChartSaldos.vue?vue&type=template&id=477a812d"
import script from "./ChartSaldos.vue?vue&type=script&lang=js"
export * from "./ChartSaldos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports